<template>
  <div class="app-container message-template">
    <basic-container>
      <avue-crud ref="crud"
        :page.sync="page"
        :data="tableData"
        :table-loading="tableLoading"
        :option="tableOption"
        @search-reset="searchReset"
        @search-change="searchChange"
        @current-change="currentChange"
        @size-change="sizeChange"
        @sort-change="sortChange"
        @refresh-change="refreshChange"
        >
        <template slot="menuLeft">
          <el-button type="primary"
            v-if="permissions.message_template_add"
            size="mini"
            @click="handleAdd">创建</el-button>
        </template>
        <template slot="menu" slot-scope="scope">
          <el-button type="text"
            v-if="permissions.message_template_view"
            icon="el-icon-view"
            size="mini"
            plain
            @click="handleView(scope.row,scope.index)">查看</el-button>
          <el-button type="text"
            v-if="permissions.message_template_edit"
            icon="el-icon-edit"
            size="mini"
            plain
            @click="handleEdit(scope.row,scope.index)">编辑</el-button>
          <el-button type="text"
            v-if="permissions.message_template_delete"
            icon="el-icon-delete"
            size="mini"
            plain
            @click="handleDelete(scope.row,scope.index)">删除</el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>
<script>
import { tableOption } from '@/const/crud/setting/template/messageTemplate'
import { fetchList, delObj } from '@/api/setting/template/messageTemplate'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      page: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      tableData: [],
      tableLoading: false,
      tableOption: tableOption,
      listQuery: {
        current: 1,
        size: 20,
        sortField: 'inserted_time',
        sortPolicy: 'desc',
        category: '',
        content: ''
      }
    }
  },
  computed: {
    ...mapGetters(['permissions'])
  },
  mounted () {
    this.getList()
  },
  methods: {
    getParams () {
      let params = {
        current: this.listQuery.current,
        size: this.listQuery.size,
        sortField: this.listQuery.sortField,
        sortPolicy: this.listQuery.sortPolicy
      }
      if (this.listQuery.category) {
        params.category = this.listQuery.category
      }
      if (this.listQuery.content) {
        params.content = this.listQuery.content
      }
      return params
    },
    getList () {
      this.tableLoading = true
      fetchList(this.getParams()).then(response => {
        this.tableData = this.formatData(response.data.data.records)
        this.page.total = response.data.data.total
        this.tableLoading = false
      }).catch(error => {
        this.$message({
          message: '获取常见问题失败',
          type: 'error'
        })
        this.tableLoading = false
      })
    },
    formatData (records) {
      return records
    },
    searchReset () {
      this.listQuery.category = ''
      this.listQuery.content = ''
      this.searchChange({})
    },
    searchChange (params) {
      this.page.currentPage = 1
      this.listQuery.current = 1
      this.listQuery.category = params.category
      this.listQuery.content = params.content
      this.getList()
    },
    currentChange (val) {
      this.page.currentPage = val
      this.listQuery.current = val
      this.getList()
    },
    sizeChange (val) {
      this.page.currentPage = 1
      this.listQuery.current = 1
      this.page.pageSize = val
      this.listQuery.size = val
      this.getList()
    },
    sortChange (val) {
      // 检查排序对象
      if (val.prop == "id") {
        this.listQuery.sortField = "id"
      } else if (val.prop == "insertedTime") {
        this.listQuery.sortField = "inserted_time"
      }
      // 检查排序方式
      if (val.order == 'ascending') {
        this.listQuery.sortPolicy = "asc"
      } else if (val.order == 'descending') {
        this.listQuery.sortPolicy = "desc"
      } else {
        this.listQuery.sortPolicy = ""
      }
      this.getList()
    },
    refreshChange () {
      this.getList()
    },
    handleAdd () {
      this.$router.push({
        path: '/setting/template/message/add'
      })
    },
    handleView (row, index) {
      this.$router.push({
        path: `/setting/template/message/detail/${row.id}`
      })
    },
    handleEdit (row, index) {
      this.$router.push({
        path: `/setting/template/message/edit/${row.id}`,
      })
    },
    handleDelete (row, index) {
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delObj(row.id).then(response => {
          if (response.data.data) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getList()
          }
        }).catch(error => {
          console.error(error)
          this.$message({
            message: '删除失败',
            type: 'error'
          })
        })
      })
    }
  }
}
</script>

